import React from 'react';
import versionInfo from '../../version.json';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 py-6 px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
        <div className="text-xs text-gray-600">
          © {currentYear} <span className="font-semibold">Teonila HouseKeeping Management</span>. Todos los derechos reservados.
        </div>
        <div className="text-xs text-gray-500">
          Versión {versionInfo.version} ({versionInfo.commitHash})
        </div>
      </div>
    </footer>
  );
};

export default Footer;
